import { TThunkAction } from '../../types/redux';
import { selectIdsForRemove, selectResults } from '../../selectors';
import {
  fetchWebDeleteFavoriteByIds,
  IWebDeleteFavoriteByIdsRequest,
} from '../../repositories/favorites/v1/web-delete-favorite-by-ids';
import { EEntityType } from '../../types/favoriteEntity';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { unselectAll } from '../../actions/selected';
import { notify } from '../../actions/notifications';
import { ENotificationStyle } from '../../types/notifications';
import { refreshFolders } from './refreshFolders';

export interface IRemoveByIdsEntity {
  entityIds: number[];
  entityType: EEntityType;
}

export interface IRemoveByIdsActionPayload {
  entities: IRemoveByIdsEntity[];
}

export const removeByIds = (entityId?: number): TThunkAction<Promise<void>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const state = getState();
  const { favoriteEntities } = selectResults(state);
  const ids = selectIdsForRemove(entityId)(state);
  const parameters: IWebDeleteFavoriteByIdsRequest = {
    entities: ids,
  };

  const showError = () => dispatch(notify('Не удалось удалить объекты из избранного', ENotificationStyle.Error));

  try {
    const { statusCode, response } = await fetchWebDeleteFavoriteByIds({ httpApi, parameters });

    if (statusCode === 200) {
      dispatch(unselectAll());
      dispatch(fetchFavoriteEntities({ offset: 0, limit: favoriteEntities.length }));
      dispatch(refreshFolders());
    }

    if (statusCode === 400) {
      showError();
      logger.warning(response.message);
    }
  } catch (e) {
    showError();
    logger.error(e, {
      description: 'Fail to remove offers from favorites',
    });
  }
};
